// Helpers para hacer peticiones REST a Supabase con el token del usuario
// adjuntado EXPLÍCITAMENTE (supabase-js no siempre lo hace bien). Garantiza
// que RLS vea auth.uid() en cada request.

import toast from 'react-hot-toast';
import { supabase, SUPABASE_URL, SUPABASE_ANON_KEY } from './supabaseClient';

export async function authHeaders() {
  const { data: { session } } = await supabase.auth.getSession();
  const token = session?.access_token;
  if (!token) {
    toast.error('Tu sesión no está activa. Inicia sesión de nuevo.');
    throw new Error('no_session');
  }
  return {
    apikey: SUPABASE_ANON_KEY,
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };
}

export async function restGet(path) {
  const headers = await authHeaders();
  const res = await fetch(`${SUPABASE_URL}/rest/v1${path}`, { headers });
  const text = await res.text();
  let json; try { json = text ? JSON.parse(text) : null; } catch { json = null; }
  if (!res.ok) throw new Error(json?.message || json?.error || `Error ${res.status}`);
  return json;
}

export async function restWrite(method, path, body, prefer = 'return=representation') {
  const headers = { ...(await authHeaders()), Prefer: prefer };
  const res = await fetch(`${SUPABASE_URL}/rest/v1${path}`, {
    method,
    headers,
    body: body != null ? JSON.stringify(body) : undefined,
  });
  const text = await res.text();
  let json; try { json = text ? JSON.parse(text) : null; } catch { json = null; }
  if (!res.ok) {
    const msg = json?.message || json?.error || `Error ${res.status}`;
    toast.error(msg);
    throw new Error(msg);
  }
  return json;
}

export const one = (rows) => (Array.isArray(rows) ? rows[0] : rows) ?? null;
